import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FullTableAccordion, ToastScreen } from 'components';
import { PendingPayableBatchesDetails } from './pendingPayableBatchesDetails';
import {
  ACTION_TYPE_CREATE_BATCH,
  ACTION_TYPE_DELETE_BATCH, ACTION_TYPE_EDIT_BATCH_TABLE,
  ACTION_TYPE_GET_BATCHES, ACTION_TYPE_PAY_CARRIER_PAYMENT_BATCH,
  ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS,
  batchStatusesEnum, CHANGE_BATCH_STATUS_APPROVE,
  pendingPayableBatchesBody,
  pendingPayableBatchesHead,
} from './constants';
import {
  batchActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
  loadActions,
} from 'store';
import { CustomDeleteModal } from 'fragments';
import { FindError, FindLoad, FindSuccess, useModal, usePrimaryModal } from 'utils';
import { LoadService } from '../../../fragments/loads/load.service';


export const PendingPayableBatches = ({ getTotals }) => {
  const [currentLoadsList, setCurrentLoadsListInfo] = useState([]);
  const [isOpeningAccordionId, setOpeningAccordionId] = useState('');
  const dispatch = useDispatch();
  const history = useHistory();
  const { batchesList } = useSelector((state) => ({
    batchesList: state.loads.batchesList,
  }));
  const { open, close } = useModal();
  const { closePrimary } = usePrimaryModal();
  const loadingLoads = FindLoad(ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS);
  const successCreateBatch = FindSuccess(ACTION_TYPE_CREATE_BATCH);
  const successEditBatchTable = FindSuccess(ACTION_TYPE_EDIT_BATCH_TABLE);
  const beckErrorPay = FindError(CHANGE_BATCH_STATUS_APPROVE);
  const info = history?.location?.state;

  const renderParams = () => {
    const filteredInfo = {
      ...info,
      status: batchStatusesEnum.UNPAID,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;

    filteredInfo?.mcs ? filteredInfo.mcs = filteredInfo.mcs?.map((mc) => mc?.id) : delete filteredInfo?.mcs;
    filteredInfo?.offices ? filteredInfo.offices = filteredInfo.offices?.map((office) => office?.id) : delete filteredInfo?.offices;

    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.viewType;
    return filteredInfo;
  };

  useEffect(() => {
    dispatch(loadActions.getAllBatches({ status: batchStatusesEnum.UNPAID }));
  }, []);

  useEffect(() => {
    if (beckErrorPay?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_PAY_CARRIER_PAYMENT_BATCH));
      toast(
        <ToastScreen
          type={'error'}
          text={beckErrorPay?.[0]?.error}
        />,
      );
    }
  }, [beckErrorPay?.[0]?.error]);


  useEffect(() => {
    dispatch(loadActions.getBatches(renderParams()));
  }, [info]);

  useEffect(() => {
    if (successCreateBatch?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_CREATE_BATCH));
      dispatch(loadActions.getBatches(renderParams(), false));
      getTotals();
      closePrimary();
    }
  }, [successCreateBatch]);

  useEffect(() => {
    if (successEditBatchTable?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_EDIT_BATCH_TABLE));
      dispatch(loadActions.getBatches(renderParams(), false));
    }
  }, [successEditBatchTable]);

  const calculateLoadTotals = () => {
    return currentLoadsList?.reduce((sum, load) => sum + LoadService.getPayableBalance(load?.payable), 0);
  };


  const handleApprove = (item) => {
    open(
      <CustomDeleteModal
        afterSuccess={() => {
          dispatch(httpRequestsOnSuccessActions.removeSuccess(CHANGE_BATCH_STATUS_APPROVE));
          dispatch(loadActions.getBatches(renderParams(), false));
          getTotals();
          close();
        }}
        actionType={CHANGE_BATCH_STATUS_APPROVE}
        text='Are you sure you want to approve this batch?'
        handleDel={(e) => {
          e.stopPropagation();
          dispatch(batchActions.changeBatchStatusToApprove(item?.id));
        }
        }
        modalText={'All orders included in this batch will be marked as approved.'}
        cancelButton={'Approve'}
        closeButton={'Go Back'}
        stylesCancelBtn={{ background: '#00C851' }}
      />);
  };

  const handleDelete = (item) => {
    open(
      <CustomDeleteModal
        afterSuccess={() => {
          dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_DELETE_BATCH));
          dispatch(loadActions.getBatches(renderParams(), false));
          getTotals();
          close();
        }}
        actionType={ACTION_TYPE_DELETE_BATCH}
        text='Delete Batch?'
        handleDel={(e) => {
          e.stopPropagation();
          dispatch(loadActions.deleteLoadsPayableBatches(item?.id));
        }
        }
        modalText={'Are you sure you want to delete this batch?'}
        cancelButton={'Delete'}
        closeButton={'Go Back'}
      />);

  };

  const changeBatchName = (id, value) => {
    if (value) {
      const updatedList = batchesList?.batches?.map((batch) => {
        if (batch?.id === id) {
          return {
            ...batch,
            name: value,
          };
        }

        return batch;
      });
      dispatch(loadActions.editBatchList({ batches: updatedList, count: batchesList?.count }));
      dispatch(loadActions.editBatchTable(id, { name: value }));
    }
  };

  return (
    <div>
      <FullTableAccordion
        head={pendingPayableBatchesHead}
        body={pendingPayableBatchesBody({
          handleApprove,
          handleDelete,
          changeBatchName,
          loadingLoads,
          isOpeningAccordionId,
          calculateLoadTotals,
        })}
        renderDetails={
          (item) => <PendingPayableBatchesDetails
            onListInfoChange={setCurrentLoadsListInfo}
            batch={item}
            getBatches={() => dispatch(loadActions.getBatches(renderParams(), false))}
            getTotals={getTotals}
          />
        }
        loadingType={ACTION_TYPE_GET_BATCHES}
        currentOpeningAccordionId={(id) => {
          setOpeningAccordionId(id);
          if (!id) {
            setCurrentLoadsListInfo([]);
          }
        }}
        list={batchesList?.batches}
        listCount={batchesList?.count}
        fixHeight={batchesList?.count ? '64vh' : '72vh'}
        noText={'Pending Batches'}
      />
    </div>
  );
};

